<template>
    <section>
        <div id="related-item" class="modal-mask" key="relatedItem">
            <div class="modal-wrapper _modalWrapper_">
                <div class="modal-container flexContainer">
                    <div class="modalBody">
                        <loader :loading="loading"></loader>
                        <div v-if="countAllBaskets > 0" class="blocAddBasket">
                            <h3>{{ $t("basket.info") }}</h3>
                            <select v-model="currentBasket" class="selectBasket">
                                <option v-for="basket in getListBasket" :key="basket.id" :value="basket.id"> {{ basket.name }} </option>
                            </select>
                            <div class="btnAddToBasket">
                                <button class="btn uppercase" @click="addToBasket();">{{ $t("basket.add") }}</button>
                            </div>
                        </div>
                        <div class="createNewBasket">
                            <h3>{{ $t("common.createBasket") }}</h3>
                            <input type="text" v-model="newBasket.name" />
                        </div>
                        <div class="actionButtons">
                            <button class="btn uppercase" @click="createNewBasket();">{{ $t("common.create") }}</button>
                            <button class="btn uppercase close" @click="close();">{{ $t("abonnement.close") }}</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import "whatwg-fetch";
import { mapGetters, mapActions } from "vuex";
import loader from "../../components/loader/loader";

export default {
    components: { loader },
    data() {
        return {
            loading: false,
            newBasket: {
                name: null,
                isCurrent: true
            },
            currentBasket: null
        };
    },
    props: {},
    watch: {},
    methods: {
        ...mapActions("basket", {
            addBasket: "list/addBasket",
            addItemBasket: "details/addItemBasket",
            populateBasketList: "list/populateBasketList"
        }),
        close() {
            this.$parent.openCreateBasket = false;
        },
        async createNewBasket() {
            if (this.newBasket.name === null) {
                this.$swal({
                    text: self.$t("messageError.addName"),
                    type: "error",
                    confirmButtonText: "OK",
                    confirmButtonColor: "red",
                    closeOnConfirm: true,
                    closeOnCancel: true,
                    allowOutsideClick: false,
                    allowEscapeKey: false
                });
            } else {
                this.loading = true;
                try {
                    const basketResult = await this.addBasket(this.newBasket);
                    await this.addItemBasket({ basketId: basketResult.id, item: this.getBasketItem });
                    this.dialogSuccess(this.$t("modalComponentCreate.successCreateTxt"));
                } catch (error) {
                    this.addItemModalError();
                } finally {
                    this.loading = false;
                    this.close();
                }
            }
        },
        async addToBasket() {
            if (this.currentBasket !== null) {
                this.loading = true;
                try {
                    await this.addItemBasket({ basketId: this.currentBasket, item: this.getBasketItem });
                    this.dialogSuccess(this.$t("modalComponentCreate.successCreateTxt"));
                } catch (error) {
                    this.addItemModalError();
                } finally {
                    this.loading = false;
                    this.close();
                }
            } else {
                this.$swal({
                    text: $t("modalComponentCreate.noBasketSelected"),
                    type: "error",
                    confirmButtonText: "OK",
                    confirmButtonColor: "red",
                    allowOutsideClick: false,
                    allowEscapeKey: false
                });
            }
        },
        addItemModalError() {
            this.$swal({
                text: this.$t("modalComponentCreate.addItemBasketError"),
                type: "error",
                confirmButtonText: "OK",
                confirmButtonColor: "#41b4e8",
                allowOutsideClick: false,
                allowEscapeKey: false
            });
        }
    },
    computed: {
        ...mapGetters("ordersStore", {
            getBasketItem: "getBasketItem",
            setBasketItemComponent: "getBasketItemComponent"
        }),
        ...mapGetters("basket", {
            getListBasket: "list/getListBasket",
            countAllBaskets: "list/countAllBaskets"
        })
    },
    mounted() {
        let basket = this.getListBasket.find(basket => basket.isCurrent === true);
        if (basket) this.currentBasket = basket.id;
    },
    created() {}
};
</script>

<style lang="scss" scoped>
@import "../../assets/css/themes";

.close {
    margin-left: 10px;
}

/* height firefox modal */
._modalWrapper_ {
    height: 100%;
}

/* end height */
.modal-mask {
    position: fixed;
    z-index: 250;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: table;
    transition: opacity 0.3s ease;
    .cross {
        top: 50px;
        right: 50px;
        z-index: 2;
    }
}

.modal-wrapper {
    display: table-cell;
    vertical-align: middle;
    .modal-container {
        width: 100%;
        height: 100%;
        margin: 0px auto;
        padding: 20px 30px;
        border-radius: 2px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
        transition: all 0.3s ease;
        font-family: Helvetica, Arial, sans-serif;
        position: relative;
        .modalBody {
            margin: auto;
            .brandWrap {
                padding: 5px;
            }
            p {
                font-family: Roboto;
                font-size: 18px;
            }
            .swiper-container-horizontal {
                .swiper-pagination {
                    margin-top: 10px;
                    position: initial;
                }
            }
            .swiper-button-prev {
                left: 25%;
                height: 15px;
            }
            .swiper-button-next {
                right: 25%;
                height: 15px;
            }
            hr {
                @extend %primary-border-color;
            }
        }
    }
}

#related-item {
    .modalBody {
        .blocAddBasket {
            @extend %primary-border-color;
            border-bottom: 1px solid;
            padding-bottom: 25px;
            margin-bottom: 25px;
        }
        .createNewBasket {
            input {
                padding: 5px;
            }
        }
        .actionButtons {
            margin-top: 30px;
            text-align: right;
        }
        h2 {
            margin-top: 0px;
        }
        h3 {
            margin-top: 0px;
            font-family: "oswald-regular", sans-serif;
            font-size: 14px;
        }
        .selectBasket {
            padding: 5px;
            width: 50%;
        }
        .btnAddToBasket {
            display: block;
            width: 100%;
            text-align: right;
            margin-top: 20px;
        }
        #selectContainer {
            margin-bottom: 30px;
        }
        width: 430px;
        @extend %second-background;
        border-radius: 4px;
        padding: 30px;
        #filterCategory {
            margin-top: 30px;
            margin-bottom: 20px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// CreateBasket.vue?7aed7f18